import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:6555');

const api = axios.create({ baseURL: BASE_URL });

const redirectExpiredAdminSession = () => {
  if (!window.location.pathname.startsWith('/admin')) return;
  if (window.location.pathname === '/admin/login') return;
  localStorage.removeItem('admin_token');
  localStorage.removeItem('portal_token');
  window.location.replace('/admin/login');
};

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token') || localStorage.getItem('portal_token');
  if (token && !config.headers.Authorization) config.headers['Authorization'] = `Bearer ${token}`;

  const initData = window.Telegram?.WebApp?.initData;
  if (initData) {
    config.headers['X-Init-Data'] = initData;
  } else {
    const devId = localStorage.getItem('dev_telegram_id');
    if (devId) config.headers['X-Telegram-Id'] = devId;
  }

  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const requestUrl = typeof err.config?.url === 'string' ? err.config.url : '';
    const isLoginRequest = requestUrl.includes('/api/auth/login');

    if (err.response?.status === 401 && !isLoginRequest) {
      redirectExpiredAdminSession();
    }
    return Promise.reject(err);
  }
);

export default api;
